import * as React from "react";
import { User } from "../../userTypes";
import { Button, Tooltip } from "@material-ui/core";
import { ConditionCheck } from "./manualVerificationConditionCheck";

type Props = {
  user: User;
  onUserChanged: (user: User) => void;
  onClick: (params?: any) => any;
  disabled: boolean;
  fetchingData: boolean;
  conditionChecks?: ConditionCheck[];
};

export default class ManualVerificationInitiateButton extends React.Component<
  Props
> {
  constructor(props: Props) {
    super(props);
    props.onUserChanged(props.user);
  }

  componentWillReceiveProps(newProps: Props) {
    if (newProps.user !== this.props.user) {
      newProps.onUserChanged(newProps.user);
    }
  }

  renderTooltipContent = () => {
    const { conditionChecks = [] } = this.props;
    const hasFailures = conditionChecks.some((check) => !check.met);

    if (!hasFailures) {
      return "Manual verification cannot be initiated right now.";
    }

    const blockers = conditionChecks.filter((check) => !check.met);

    return (
      <div style={{ fontSize: 13 }}>
        <div style={{ marginBottom: 4 }}>
          <strong>Cannot start manual verification because:</strong>
        </div>
        <ul style={{ margin: "4px 0 0", paddingLeft: 18 }}>
          {blockers.map((check) => (
            <li key={check.id} style={{ marginTop: 4 }}>
              {check.label}
            </li>
          ))}
        </ul>
      </div>
    );
  };

  render() {
    return this.props.disabled === false &&
      this.props.fetchingData === false ? (
      <Button
        color="primary"
        variant="contained"
        className="button no-margin"
        onClick={this.props.onClick}
        disabled={this.props.disabled}
      >
        Initiate manual verification
      </Button>
    ) : (
      <Tooltip
        title={this.renderTooltipContent()}
        placement="bottom-start"
      >
        <span>
          <Button
            color="primary"
            variant="contained"
            className="button no-margin"
            onClick={this.props.onClick}
            disabled={this.props.disabled}
          >
            Initiate manual verification
          </Button>
        </span>
      </Tooltip>
    );
  }
}
